module.exports = __webpack_public_path__ + "static/media/logo.4638c413.png";